import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

interface INotificationState {
  testid: number;
  denomination: string;
  test_status: string;
}
interface INotificationsState {
  items: INotificationState[]|[];
}

const initialState: INotificationsState = {
  items: []
};

const notificationsInit = ( state: INotificationsState, action: any ) => {
  return updateObject( state, { items: action.notificationData } );
};

const markAsReadNotification = ( state: INotificationsState, action: any ) => {
  return updateObject( state, {
    items: state.items.filter((notification:any) => notification.testid !== action.test_id)
  } );
};

const reducer = ( state = initialState, action: any ) => {
  switch ( action.type ) {
    case actionTypes.NOTIFICATION_INIT: return notificationsInit( state, action );
    case actionTypes.NOTIFICATION_MARK_AS_READ: return markAsReadNotification( state, action );
    default: return state;
  }
};

export default reducer;
